import React from 'react'

import axios from 'axios'
import { useNavigate } from 'react-router-dom'
// Criado um React Context para o Login de usuário;
// Esse React Context que se chama LoginContext envolve toda a aplicação;
// Assim em qualquer parte da aplicação saberemos se o usuário está logado ou não;
// Adicionado no localstorage também
export const LoginContext = React.createContext()

// LoginProvider é o componente que é chamado lá no index.js inicial e retorna o LoginContext.Provider com os values que vamos usar
export const LoginProvider = (props) => {
  const [input, setInput] = React.useState({ user: '', password: '' });
  const [auth, setAuth] = React.useState({ user: '', auth: false, token: '' });
  const [pageInit, setPageInit] = React.useState('')
  const [modal, setModal] = React.useState({ ativo: false, message: '', error: false, pathname: '' })
  const navigate = useNavigate();
  // Se iniciar a aplicação com qualquer página que não seja /login e não tiver o usuario no localstorage, direcionado para o login 
  React.useEffect(() => {
    if (window.location.pathname !== '/login') {
      if (localStorage.getItem('user')) {
        setAuth(JSON.parse(localStorage.getItem('user')))
      } else {
        setPageInit(window.location.pathname)
        navigate('/login')
      }
    } else {
       // Mas se acessar login com o usuario no localstorage, faremos o logout
      if (localStorage.getItem('user')) {
        localStorage.removeItem('user')
      }
      setAuth({ user: '', auth: false, token: '' })

    }
    setModal(modal=>({ ...modal, pathname: window.location.pathname }))
  }, [navigate])


  function handleLogin(e) {
    setModal({ ...modal, ativo: true, message: 'Carregando', error: false })
    e.preventDefault()
    axios
      .post(`${process.env.REACT_APP_API_URL}/login`, input)
      .then((response) => {
        setAuth({ user: input.user, auth: response.data.auth, token: response.data.token })
        localStorage.setItem('user', JSON.stringify({ user: input.user, auth: response.data.auth, token: response.data.token }))
        setModal({ ...modal, ativo: false, error: false, })
        if (pageInit !== '/login' && pageInit !== '') {
          navigate(pageInit);
        } else {
          navigate('/wines');
        }
      })
      .catch((error) => {
        setModal({ ...modal, ativo: true, message: `${error}`, error: true }) 
      });
  }

  return (
    <LoginContext.Provider value={{ input, setInput, auth, setAuth, handleLogin, modal, setModal }}>
      {props.children}
    </LoginContext.Provider>
  )
}



